import React from "react"
import {Icon} from "nhsuk-react-components"

const SuccessOrFail: React.FC<{condition: boolean}> = ({
  condition
}) => {
  return condition
    ? <Icon modifier="tick" className="nhsuk-icon__tick" />
    : <Icon modifier="cross" className="nhsuk-icon__cross" />
}

export default SuccessOrFail
